// Mock data for Alabama Buddhist Viharaya website

export const templeInfo = {
  name: "Alabama Buddhist Vihara",
  tagline: "A place of peace, meditation, and wisdom",
  phone: "(727) 504-0518",
  phone2: "(205) 201-2881",
  email: "alvihara@gmail.com",
  address: "2100 Hardwick Road, Pell City, Alabama 35128"
};

export const danaSchedule = [
  { date: 1, donor: "Mrs. Nalini", month: "Every Month", isMonthly: true },
  { date: 2, donor: "Available", month: "January" },
  { date: 3, donor: "Available", month: "January" },
  { date: 4, donor: "Mrs. Lalanika", month: "Every Month", isMonthly: true },
  { date: 5, donor: "Mrs. Chinthani", month: "Every Month", isMonthly: true },
  { date: 6, donor: "Available", month: "January" },
  { date: 7, donor: "Available", month: "January" },
  { date: 8, donor: "Available", month: "January" },
  { date: 9, donor: "Mr. Saman", month: "Every Month", isMonthly: true },
  { date: 10, donor: "Available", month: "January" },
  { date: 11, donor: "Available", month: "January" },
  { date: 12, donor: "Available", month: "January" },
  { date: 13, donor: "Mr. Madhura", month: "Every Month", isMonthly: true },
  { date: 14, donor: "Available", month: "January" },
  { date: 15, donor: "Mrs. Nalani", month: "Every Month", isMonthly: true },
  { date: 16, donor: "Mr. Saman", month: "Every Month", isMonthly: true },
  { date: 17, donor: "Available", month: "January" },
  { date: 18, donor: "Available", month: "January" },
  { date: 19, donor: "Available", month: "January" },
  { date: 20, donor: "Available", month: "January" },
  { date: 21, donor: "Available", month: "January" },
  { date: 22, donor: "Available", month: "January" },
  { date: 23, donor: "Available", month: "January" },
  { date: 24, donor: "Available", month: "January" },
  { date: 25, donor: "Mr. Asiri", month: "Every Month", isMonthly: true },
  { date: 26, donor: "Mr. Ruwan", month: "Every Month", isMonthly: true },
  { date: 27, donor: "Available", month: "January" },
  { date: 28, donor: "Available", month: "January" },
  { date: 29, donor: "Available", month: "January" },
  { date: 30, donor: "Mr. Neranga", month: "Every Month", isMonthly: true },
  { date: 31, donor: "Available", month: "January" }
];

export const programs = [
  {
    id: 1,
    title: "Meditation Classes",
    description: "Learn mindfulness and Vipassana meditation techniques for inner peace and clarity.",
    schedule: "Every Wednesday & Sunday 6:00 PM",
    icon: "Brain"
  },
  {
    id: 2,
    title: "Dharma Preaching",
    description: "Weekly teachings on Buddha's wisdom and the path to enlightenment.",
    schedule: "",
    icon: "Book"
  },
  {
    id: 3,
    title: "Sunday Children's Class",
    description: "Buddhist education and values for children in a supportive environment.",
    schedule: "First Sunday of Each Month, 2:00 PM - 4:00 PM",
    icon: "Users"
  },
  {
    id: 4,
    title: "Personal Counseling",
    description: "One-on-one guidance for life challenges, meditation practice, and spiritual growth.",
    schedule: "By Appointment",
    icon: "Heart"
  }
];

export const events = [
  {
    id: 1,
    title: "Special Poson Poya Program 2026",
    date: "Sunday, June 28, 2026",
    description: "A historic religious program following the Grand Opening of our new temple location, with Most Venerable Athbatuwe Hemaloka Thero and Most Venerable Thelulle Pannaloka Thero from Sri Lanka.",
    featured: true,
    isSpecial: true,
    details: [
      "The Alabama Buddhist Vihara is deeply honored to announce a special Poson Poya Program to be held on Sunday, June 28, 2026, following the Grand Opening of our new temple location in Pell City, Alabama.",
      "For this important and historic occasion, we have officially invited our respected teacher, Most Venerable Athbatuwe Hemaloka Thero, together with the well-known and experienced Dhamma preacher, Most Venerable Thelulle Pannaloka Thero, from Sri Lanka to participate in and bless this special religious program.",
      "They have been invited to offer Dhamma teachings, blessings, spiritual guidance, and religious observances for the Sri Lankan Buddhist community and all attendees at the Alabama Buddhist Vihara.",
      "This Poson program will be one of the first major religious events held at our new vihara location after the grand opening ceremony.",
      "More details about the program schedule will be announced soon through our website and social media pages.",
      "We warmly invite everyone to join us for this meaningful and blessed gathering."
    ]
  },
  {
    id: 2,
    title: "Monthly Poya Day Observance",
    date: "Every Full Moon",
    description: "Special meditation sessions and dharma discussions on the sacred full moon days.",
    featured: false
  },
  {
    id: 3,
    title: "Community Dana",
    date: "",
    description: "Community gathering with shared meals and teachings.",
    featured: false
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Williams",
    text: "This temple helped me find peace in my life. The meditation practices have transformed my daily routine and brought me closer to understanding myself.",
    role: "Regular Visitor"
  },
  {
    id: 2,
    name: "Raj Patel",
    text: "Meditation here changed my mind and heart. The teachings are profound yet accessible, and the community is warm and welcoming.",
    role: "Meditation Student"
  },
  {
    id: 3,
    name: "Jennifer Lee",
    text: "The children's Sunday school has been wonderful for my kids. They're learning valuable life lessons and Buddhist values in a caring environment.",
    role: "Parent"
  },
  {
    id: 4,
    name: "Michael Thompson",
    text: "A sanctuary of calm in our busy lives. The dharma teachings have given me clarity and purpose.",
    role: "Community Member"
  }
];

export const teachings = [
  {
    id: 1,
    title: "The Four Noble Truths",
    category: "Core Teachings",
    description: "Understanding the nature of suffering and the path to liberation.",
    content: "The Buddha's first teaching after enlightenment, explaining the fundamental truths about existence."
  },
  {
    id: 2,
    title: "The Noble Eightfold Path",
    category: "Core Teachings",
    description: "The path to the end of suffering through right understanding, intention, speech, action, livelihood, effort, mindfulness, and concentration.",
    content: "A practical guide to ethical and mental development with the goal of freeing the individual from attachments and delusions."
  },
  {
    id: 3,
    title: "Loving-Kindness (Metta)",
    category: "Meditation",
    description: "Cultivating unconditional love and compassion for all beings.",
    content: "A meditation practice that develops feelings of goodwill, kindness and warmth towards others."
  },
  {
    id: 4,
    title: "Vipassana Meditation",
    category: "Meditation",
    description: "Insight meditation to see things as they truly are.",
    content: "One of India's most ancient meditation techniques, teaching self-observation and the interconnection between mind and body."
  },
  {
    id: 5,
    title: "Daily Reflections",
    category: "Practice",
    description: "Mindful living and bringing Buddhist wisdom into everyday life.",
    content: "Practical guidance for incorporating Buddhist principles into daily activities and decisions."
  },
  {
    id: 6,
    title: "The Five Precepts",
    category: "Ethics",
    description: "Basic ethical guidelines for Buddhist practitioners.",
    content: "Principles of non-harming, truthfulness, respect, mindfulness, and clarity of mind."
  }
];

export const buddhaLife = {
  sections: [
    {
      title: "Birth of Prince Siddhartha",
      content: "Born in Lumbini, Nepal around 563 BCE, Prince Siddhartha Gautama was destined for greatness. His father, King Suddhodana, sheltered him from the world's suffering within palace walls."
    },
    {
      title: "The Four Sights",
      content: "At age 29, Siddhartha ventured beyond the palace and encountered four significant sights: an old man, a sick person, a corpse, and a wandering monk. These encounters awakened him to the reality of suffering and inspired his spiritual quest."
    },
    {
      title: "The Great Renunciation",
      content: "Leaving behind his royal life, wife, and newborn son, Siddhartha embarked on a spiritual journey, seeking answers to life's fundamental questions about suffering, aging, and death."
    },
    {
      title: "The Enlightenment",
      content: "After six years of ascetic practices and deep meditation, Siddhartha sat under the Bodhi tree in Bodh Gaya. On the full moon night, he achieved complete enlightenment, understanding the true nature of reality and becoming the Buddha - 'The Awakened One.'"
    },
    {
      title: "Teaching the Dharma",
      content: "For 45 years, the Buddha traveled throughout India, teaching the Dharma - the path to liberation from suffering. He established the Sangha, the community of monks and nuns, and taught countless disciples."
    },
    {
      title: "Parinirvana",
      content: "At age 80, in Kushinagar, India, the Buddha passed into Parinirvana - the final release from the cycle of birth and death. His final words were: 'All conditioned things are impermanent. Strive on with diligence.'"
    }
  ]
};

export const aboutContent = {
  mission: "Alabama Buddhist Viharaya is dedicated to preserving and sharing the authentic teachings of Theravada Buddhism. We provide a peaceful sanctuary for meditation, learning, and spiritual growth.",
  vision: "To create a compassionate community where individuals can discover inner peace, develop wisdom, and cultivate loving-kindness towards all beings.",
  values: [
    "Authentic Theravada Buddhist teachings",
    "Regular meditation and mindfulness practice",
    "Community support and service",
    "Education for children and adults",
    "Compassion and loving-kindness for all"
  ]
};
